export const LOCAL_STORAGE_KEY_VIEWED_ITEMS = "viewedItems"

export function CreateLocalStorageKeyViewedItems(
  enterpriseID: string,
  shopID: string
): string {
  return `${LOCAL_STORAGE_KEY_VIEWED_ITEMS}_${enterpriseID}_${shopID}`
}
